import noop from "lib/noop"
import { useRefresh } from "lib/@hooks/useRefresh"
import { Bound } from "lib/@components/binding/Bound"
import { useBoundContext } from "lib/@components/binding/use-bound-context"

export function BoundObjectEditor({ target: initialValue, onChange = noop, ...props }) {
    const refresh = useRefresh()
    const { target } = useBoundContext()
    initialValue ??= target

    return <Bound target={initialValue} refresh={refresh} onChange={onChange} {...props} />
}
